module.exports = __webpack_public_path__ + "static/media/Data-Security-and-Privacy.3375b739.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-ASURION/Data-Security-and-Privacy.jpg
// module id = 3771
// module chunks = 0